import {
  CUREWIKI_HOSTNAMES,
  YWC_HOSTNAMES,
  BHS_HOSTNAMES,
  PCE_HOSTNAMES,
  PEC_HOSTNAMES,
} from '@app/constants';

export enum Domains {
  BHS = 'bhs',
  CUREWIKI = 'curewiki',
  PCE = 'pce',
  PEC = 'pec',
  YWC = 'ywc',
}

const domainMapper = [
  ...CUREWIKI_HOSTNAMES,
  ...YWC_HOSTNAMES,
  ...BHS_HOSTNAMES,
  ...PCE_HOSTNAMES,
  ...PEC_HOSTNAMES,
].reduce<{
  [key: string]: Domains;
}>((result, hostname) => {
  const newResult = { ...result };
  if (CUREWIKI_HOSTNAMES.includes(hostname)) {
    newResult[hostname] = Domains.CUREWIKI;
  } else if (YWC_HOSTNAMES.includes(hostname)) {
    newResult[hostname] = Domains.YWC;
  } else if (BHS_HOSTNAMES.includes(hostname)) {
    newResult[hostname] = Domains.BHS;
  } else if (PCE_HOSTNAMES.includes(hostname)) {
    newResult[hostname] = Domains.PCE;
  } else if (PEC_HOSTNAMES.includes(hostname)) {
    newResult[hostname] = Domains.PEC;
  }

  return newResult;
}, {});

type domainMapperKeys = keyof typeof domainMapper;

export const useDomain = () => {
  const appType = import.meta.env.VITE_APP_TYPE || '';
  if (appType === Domains.YWC) return Domains.YWC;
  if (appType === Domains.BHS) return Domains.BHS;
  if (appType === Domains.PCE) return Domains.PCE;
  if (appType === Domains.PEC) return Domains.PEC;

  const mappedDomain = domainMapper[window.location.hostname as domainMapperKeys];
  return mappedDomain || Domains.CUREWIKI;
};
